import AddPatient from './AddPatientForm'

export default AddPatient 